// extracted by mini-css-extract-plugin
export var body = "_bw-0";
export var sectionHeader = "_bw-4";
export var shortcutColumns = "_bw-2";
export var shortcutList = "_bw-1";
export var shortcutSection = "_bw-3";